(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["descuentos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.paralia-ds__arrow');
  if (!btn) return;
  var slider = btn.closest('.paralia-ds');
  if (!slider) return;
  var track = slider.querySelector('.paralia-ds__track');
  var card = track.querySelector('.paralia-ds__card');
  var gap = parseInt(getComputedStyle(track).columnGap) || 16;
  var step = card ? card.offsetWidth + gap : track.clientWidth * 0.8;
  track.scrollBy({ left: btn.dataset.dir === 'prev' ? -step : step, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();
})();
